import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";
import { GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_VERSION } from "../config/googleMaps";
import "../styles/SmrutiMap.css";

const DEFAULT_CENTER = { lat: 22.5579883, lng: 72.9171417 };
const MAP_FOCUS_AREAS = [
  {
    key: "gujarat",
    label: "Gujarat",
    bounds: { north: 24.8, south: 20.1, east: 74.7, west: 68.0 },
  },
  {
    key: "mumbai",
    label: "Mumbai",
    center: { lat: 19.076, lng: 72.8777 },
    zoom: 10,
  },
  {
    key: "bangaluru",
    label: "Bangaluru",
    center: { lat: 12.9716, lng: 77.5946 },
    zoom: 10,
  },
  {
    key: "uk",
    label: "UK",
    bounds: { north: 59.0, south: 49.8, east: 2.2, west: -8.7 },
  },
  {
    key: "switzerland",
    label: "Switzerland",
    bounds: { north: 47.9, south: 45.7, east: 10.7, west: 5.8 },
  },
];

const resolvePublicAssetPath = (path) => {
  const basePath = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${basePath}${normalizedPath}`;
};

const cityGeoJsonConfig = {
  vadodara: {
    filePath: "/map/geojson/geojson/Vadodara-Surrounding.geojson",
    color: "#E3027A",
    opacity: 0.5,
    strokeColor: "#E3027A",
    pradeshName: "Hariswarup Pradesh",
    displayName: "Vadodara",
  },
  nadiad: {
    filePath: "/map/geojson/geojson/Nadiad-Taluka.geojson",
    color: "orange",
    opacity: 0.5,
    strokeColor: "orange",
    pradeshName: "Harisumiran Pradesh",
    displayName: "Nadiad",
  },
  bakrol: {
    filePath: "/map/geojson/geojson/Bakrol-VVN-Anand.geojson",
    color: "orange",
    opacity: 0.7,
    strokeColor: "orange",
    pradeshName: "Harisumiran Pradesh",
    displayName: "Bakrol",
  },
  jambusartaluka: {
    filePath: "/map/geojson/geojson/Jambusar-Taluka.geojson",
    color: "#9CA352",
    opacity: 0.5,
    strokeColor: "#9CA352",
    pradeshName: "Hariakshar Pradesh",
    displayName: "Jambusar Taluka",
  },
  padrataluka: {
    filePath: "/map/geojson/geojson/Padra-Taluka.geojson",
    color: "#9CA352",
    opacity: 0.5,
    strokeColor: "#9CA352",
    pradeshName: "Hariakshar Pradesh",
    displayName: "Padra Taluka",
  },
  dabhoitaluka: {
    filePath: "/map/geojson/geojson/Dabhoi-Taluka.geojson",
    color: "#52A384",
    opacity: 0.5,
    strokeColor: "#52A384",
    pradeshName: "Haripriy Pradesh",
    displayName: "Dabhoi Taluka",
  },
  chhotaudepurtaluka: {
    filePath: "/map/geojson/geojson/Chootaudepur-Taluka.geojson",
    color: "#52A384",
    opacity: 0.5,
    strokeColor: "#52A384",
    pradeshName: "Haripriy Pradesh",
    displayName: "Chhota Udepur Taluka",
  },
  nasvaditaluka: {
    filePath: "/map/geojson/geojson/Nasvadi-Taluka.geojson",
    color: "#52A384",
    opacity: 0.5,
    strokeColor: "#52A384",
    pradeshName: "Haripriy Pradesh",
    displayName: "Nasvadi Taluka",
  },
  kavattaluka: {
    filePath: "/map/geojson/geojson/Kavat-Taluka.geojson",
    color: "#52A384",
    opacity: 0.5,
    strokeColor: "#52A384",
    pradeshName: "Haripriy Pradesh",
    displayName: "Kavat Taluka",
  },
  amodtaluka: {
    filePath: "/map/geojson/geojson/Amod-Taluka.geojson",
    color: "#A35252",
    opacity: 0.7,
    strokeColor: "#A35252",
    pradeshName: "Harimanan Pradesh",
    displayName: "Amod Taluka",
  },
  karjantaluka: {
    filePath: "/map/geojson/geojson/Karjan-Taluka.geojson",
    color: "#A35252",
    opacity: 0.7,
    strokeColor: "#A35252",
    pradeshName: "Harimanan Pradesh",
    displayName: "Karjan Taluka",
  },
  sinortaluka: {
    filePath: "/map/geojson/geojson/Sinor-Taluka.geojson",
    color: "#A35252",
    opacity: 0.7,
    strokeColor: "#A35252",
    pradeshName: "Harimanan Pradesh",
    displayName: "Sinor Taluka",
  },
  vagrataluka: {
    filePath: "/map/geojson/geojson/Vagra-Taluka.geojson",
    color: "#A35252",
    opacity: 0.7,
    strokeColor: "#A35252",
    pradeshName: "Harimanan Pradesh",
    displayName: "Vagra Taluka",
  },
  por: {
    filePath: "/map/geojson/geojson/Por.geojson",
    color: "#A35252",
    opacity: 0.7,
    strokeColor: "#A35252",
    pradeshName: "Harimanan Pradesh",
    displayName: "Por",
  },
  junagadhtaluka: {
    filePath: "/map/geojson/geojson/Junagadh-Taluka.geojson",
    color: "yellow",
    opacity: 0.7,
    strokeColor: "yellow",
    pradeshName: "Hariashray Pradesh",
    displayName: "Junagadh Taluka",
  },
  keshodtaluka: {
    filePath: "/map/geojson/geojson/Keshod-Taluka.geojson",
    color: "yellow",
    opacity: 0.7,
    strokeColor: "yellow",
    pradeshName: "Hariashray Pradesh",
    displayName: "Keshod Taluka",
  },
  manavadartaluka: {
    filePath: "/map/geojson/geojson/Manavadar-Taluka.geojson",
    color: "yellow",
    opacity: 0.7,
    strokeColor: "yellow",
    pradeshName: "Hariashray Pradesh",
    displayName: "Manavadar Taluka",
  },
  dhorajitaluka: {
    filePath: "/map/geojson/geojson/Dhoraji-Taluka.geojson",
    color: "yellow",
    opacity: 0.7,
    strokeColor: "yellow",
    pradeshName: "Hariashray Pradesh",
    displayName: "Dhoraji Taluka",
  },
  upletataluka: {
    filePath: "/map/geojson/geojson/Upleta-Taluka.geojson",
    color: "yellow",
    opacity: 0.7,
    strokeColor: "yellow",
    pradeshName: "Hariashray Pradesh",
    displayName: "Upleta Taluka",
  },
  vanthalitaluka: {
    filePath: "/map/geojson/geojson/Vanthali-Taluka.geojson",
    color: "yellow",
    opacity: 0.7,
    strokeColor: "yellow",
    pradeshName: "Hariashray Pradesh",
    displayName: "Vanthali Taluka",
  },
  bhavnagar: {
    filePath: "/map/geojson/geojson/Bhavnagar.geojson",
    color: "yellow",
    opacity: 0.7,
    strokeColor: "yellow",
    pradeshName: "Hariashray Pradesh",
    displayName: "Bhavnagar",
  },
  vadhavan: {
    filePath: "/map/geojson/geojson/Vadhavan.geojson",
    color: "yellow",
    opacity: 0.7,
    strokeColor: "yellow",
    pradeshName: "Hariashray Pradesh",
    displayName: "Vadhavan",
  },
  rajkottaluka: {
    filePath: "/map/geojson/geojson/Rajkot-Taluka.geojson",
    color: "blue",
    opacity: 0.5,
    strokeColor: "blue",
    pradeshName: "Hariamrut Pradesh",
    displayName: "Rajkot Taluka",
  },
  jasdantaluka: {
    filePath: "/map/geojson/geojson/Jasdan-Taluka.geojson",
    color: "blue",
    opacity: 0.5,
    strokeColor: "blue",
    pradeshName: "Hariamrut Pradesh",
    displayName: "Jasdan Taluka",
  },
  jamnagartaluka: {
    filePath: "/map/geojson/geojson/Jamnagar-Taluka.geojson",
    color: "blue",
    opacity: 0.5,
    strokeColor: "blue",
    pradeshName: "Hariamrut Pradesh",
    displayName: "Jamnagar Taluka",
  },
  morbitaluka: {
    filePath: "/map/geojson/geojson/Morbi-Taluka.geojson",
    color: "blue",
    opacity: 0.5,
    strokeColor: "blue",
    pradeshName: "Hariamrut Pradesh",
    displayName: "Morbi Taluka",
  },
  bhujtaluka: {
    filePath: "/map/geojson/geojson/Bhuj-Taluka.geojson",
    color: "red",
    opacity: 0.5,
    strokeColor: "red",
    pradeshName: "Hariprerit Pradesh",
    displayName: "Bhuj Taluka",
  },
  anjartaluka: {
    filePath: "/map/geojson/geojson/Anjar-Taluka.geojson",
    color: "red",
    opacity: 0.5,
    strokeColor: "red",
    pradeshName: "Hariprerit Pradesh",
    displayName: "Anjar Taluka",
  },
  mandavitaluka: {
    filePath: "/map/geojson/geojson/Mandavi-Taluka.geojson",
    color: "red",
    opacity: 0.5,
    strokeColor: "red",
    pradeshName: "Hariprerit Pradesh",
    displayName: "Mandavi Taluka",
  },
  gandhidham: {
    filePath: "/map/geojson/geojson/Gandhidham.geojson",
    color: "red",
    opacity: 0.5,
    strokeColor: "red",
    pradeshName: "Hariprerit Pradesh",
    displayName: "Gandhidham",
  },
  kaditaluka: {
    filePath: "/map/geojson/geojson/Kadi-Taluka.geojson",
    color: "green",
    opacity: 0.5,
    strokeColor: "green",
    pradeshName: "Haribhakti Pradesh",
    displayName: "Kadi Taluka",
  },
  mehsanataluka: {
    filePath: "/map/geojson/geojson/Mehsana-Taluka.geojson",
    color: "green",
    opacity: 0.5,
    strokeColor: "green",
    pradeshName: "Haribhakti Pradesh",
    displayName: "Mehsana Taluka",
  },
  patantaluka: {
    filePath: "/map/geojson/geojson/Patan-Taluka.geojson",
    color: "green",
    opacity: 0.5,
    strokeColor: "green",
    pradeshName: "Haribhakti Pradesh",
    displayName: "Patan Taluka",
  },
  unjhataluka: {
    filePath: "/map/geojson/geojson/Unjha-Taluka.geojson",
    color: "green",
    opacity: 0.5,
    strokeColor: "green",
    pradeshName: "Haribhakti Pradesh",
    displayName: "Unjha Taluka",
  },
  palanpurtaluka: {
    filePath: "/map/geojson/geojson/Palanpur-Taluka.geojson",
    color: "green",
    opacity: 0.5,
    strokeColor: "green",
    pradeshName: "Haribhakti Pradesh",
    displayName: "Palanpur Taluka",
  },
  amadavadtaluka: {
    filePath: "/map/geojson/geojson/Amadavad-Taluka.geojson",
    color: "#00BBF5",
    opacity: 0.6,
    strokeColor: "#00BBF5",
    pradeshName: "Harimay Pradesh",
    displayName: "Amadavad Taluka",
  },
  gandhinagartaluka: {
    filePath: "/map/geojson/geojson/Gandhinagar-Taluka.geojson",
    color: "#00BBF5",
    opacity: 0.6,
    strokeColor: "#00BBF5",
    pradeshName: "Harimay Pradesh",
    displayName: "Gandhinagar Taluka",
  },
  amadavad: {
    filePath: "/map/geojson/geojson/Amadavad-City.geojson",
    color: "#00BBF5",
    opacity: 0.6,
    strokeColor: "#00BBF5",
    pradeshName: "Harimay Pradesh",
    displayName: "Amadavad City",
  },
  savalitaluka: {
    filePath: "/map/geojson/geojson/Savali-Taluka.geojson",
    color: "#67A0DB",
    opacity: 0.6,
    strokeColor: "#67A0DB",
    pradeshName: "Haridarshan Pradesh",
    displayName: "Savali Taluka",
  },
  haloltaluka: {
    filePath: "/map/geojson/geojson/Halol-Taluka.geojson",
    color: "#67A0DB",
    opacity: 0.6,
    strokeColor: "#67A0DB",
    pradeshName: "Haridarshan Pradesh",
    displayName: "Halol Taluka",
  },
  godharataluka: {
    filePath: "/map/geojson/geojson/Godhara-Taluka.geojson",
    color: "#67A0DB",
    opacity: 0.6,
    strokeColor: "#67A0DB",
    pradeshName: "Haridarshan Pradesh",
    displayName: "Godhara Taluka",
  },
  sokhada: {
    filePath: "/map/geojson/geojson/Sokhada.geojson",
    color: "#67A0DB",
    opacity: 0.6,
    strokeColor: "#67A0DB",
    pradeshName: "Haridarshan Pradesh",
    displayName: "Sokhada",
  },
  asoj: {
    filePath: "/map/geojson/geojson/Asoj.geojson",
    color: "#67A0DB",
    opacity: 0.6,
    strokeColor: "#67A0DB",
    pradeshName: "Haridarshan Pradesh",
    displayName: "Asoj",
  },
  virod: {
    filePath: "/map/geojson/geojson/Virod.geojson",
    color: "#67A0DB",
    opacity: 0.6,
    strokeColor: "#67A0DB",
    pradeshName: "Haridarshan Pradesh",
    displayName: "Virod",
  },
  bhaniyara: {
    filePath: "/map/geojson/geojson/Bhaniyara.geojson",
    color: "#67A0DB",
    opacity: 0.6,
    strokeColor: "#67A0DB",
    pradeshName: "Haridarshan Pradesh",
    displayName: "Bhaniyara",
  },
  ganeshpura: {
    filePath: "/map/geojson/geojson/Ganeshpura.geojson",
    color: "#67A0DB",
    opacity: 0.9,
    strokeColor: "#67A0DB",
    pradeshName: "Haridarshan Pradesh",
    displayName: "Ganeshpura",
  },
  bharuchtaluka: {
    filePath: "/map/geojson/geojson/Bharuch-Taluka.geojson",
    color: "#DB4A2E",
    opacity: 0.5,
    strokeColor: "#DB4A2E",
    pradeshName: "Harisanmukh Pradesh",
    displayName: "Bharuch Taluka",
  },
  ankleshwartalula: {
    filePath: "/map/geojson/geojson/Ankleshwar-Taluka.geojson",
    color: "#DB4A2E",
    opacity: 0.5,
    strokeColor: "#DB4A2E",
    pradeshName: "Harisanmukh Pradesh",
    displayName: "Ankleshwar Taluka",
  },
  kamrejtaluka: {
    filePath: "/map/geojson/geojson/Kamrej-Taluka.geojson",
    color: "#A3529F",
    opacity: 0.5,
    strokeColor: "#A3529F",
    pradeshName: "Harichintan Pradesh",
    displayName: "Kamrej Taluka",
  },
  olpadtaluka: {
    filePath: "/map/geojson/geojson/Olpad-Taluka.geojson",
    color: "#A3529F",
    opacity: 0.5,
    strokeColor: "#A3529F",
    pradeshName: "Harichintan Pradesh",
    displayName: "Olpad Taluka",
  },
  mangroltaluka: {
    filePath: "/map/geojson/geojson/Mangrol-Taluka.geojson",
    color: "#A3529F",
    opacity: 0.5,
    strokeColor: "#A3529F",
    pradeshName: "Harichintan Pradesh",
    displayName: "Mangrol Taluka",
  },
  surat: {
    filePath: "/map/geojson/geojson/Surat-City.geojson",
    color: "#1CADAD",
    opacity: 0.5,
    strokeColor: "#1CADAD",
    pradeshName: "Harinaman Pradesh",
    displayName: "Surat City",
  },
  jalalportaluka: {
    filePath: "/map/geojson/geojson/Jalalpor-Taluka.geojson",
    color: "#1CADAD",
    opacity: 0.5,
    strokeColor: "#1CADAD",
    pradeshName: "Harinaman Pradesh",
    displayName: "Jalalpor Taluka",
  },
  gandevitaluka: {
    filePath: "/map/geojson/geojson/Gandevi-Taluka.geojson",
    color: "#64E302",
    opacity: 0.5,
    strokeColor: "#64E302",
    pradeshName: "Haricharan Pradesh",
    displayName: "Gandevi Taluka",
  },
  valsadtaluka: {
    filePath: "/map/geojson/geojson/Valsad-Taluka.geojson",
    color: "#64E302",
    opacity: 0.5,
    strokeColor: "#64E302",
    pradeshName: "Haricharan Pradesh",
    displayName: "Valsad Taluka",
  },
  vapitaluka: {
    filePath: "/map/geojson/geojson/Vapi-Taluka.geojson",
    color: "#64E302",
    opacity: 0.5,
    strokeColor: "#64E302",
    pradeshName: "Haricharan Pradesh",
    displayName: "Vapi Taluka",
  },
  umargamtaluka: {
    filePath: "/map/geojson/geojson/Umargam-Taluka.geojson",
    color: "#64E302",
    opacity: 0.5,
    strokeColor: "#64E302",
    pradeshName: "Haricharan Pradesh",
    displayName: "Umargam Taluka",
  },
  mumbai: {
    filePath: "/map/geojson/geojson/Mumbai-District.geojson",
    color: "#5952A3",
    opacity: 0.5,
    strokeColor: "#5952A3",
    pradeshName: "Harihraday Pradesh",
    displayName: "Mumbai District",
  },
  petladtaluka: {
    filePath: "/map/geojson/geojson/Petlad-Taluka.geojson",
    color: "#18DBD7",
    opacity: 0.6,
    strokeColor: "#18DBD7",
    pradeshName: "Haritanay Pradesh",
    displayName: "Petlad Taluka",
  },
  thasrataluka: {
    filePath: "/map/geojson/geojson/Thasra-Taluka.geojson",
    color: "#18DBD7",
    opacity: 0.6,
    strokeColor: "#18DBD7",
    pradeshName: "Haritanay Pradesh",
    displayName: "Thasra Taluka",
  },
  kapadvanjtaluka: {
    filePath: "/map/geojson/geojson/Kapadvanj-Taluka.geojson",
    color: "#18DBD7",
    opacity: 0.6,
    strokeColor: "#18DBD7",
    pradeshName: "Haritanay Pradesh",
    displayName: "Kapadvanj Taluka",
  },
  balasinortaluka: {
    filePath: "/map/geojson/geojson/Balasinor-Taluka.geojson",
    color: "#18DBD7",
    opacity: 0.6,
    strokeColor: "#18DBD7",
    pradeshName: "Haritanay Pradesh",
    displayName: "Balasinor Taluka",
  },
  borsadtaluka: {
    filePath: "/map/geojson/geojson/Borsad-Taluka.geojson",
    color: "#18DBD7",
    opacity: 0.6,
    strokeColor: "#18DBD7",
    pradeshName: "Haritanay Pradesh",
    displayName: "Borsad Taluka",
  },
  anklavtaluka: {
    filePath: "/map/geojson/geojson/Anklav-Taluka.geojson",
    color: "#18DBD7",
    opacity: 0.6,
    strokeColor: "#18DBD7",
    pradeshName: "Haritanay Pradesh",
    displayName: "Anklav Taluka",
  },
  nagpur: {
    filePath: "/map/geojson/geojson/Nagpur.geojson",
    color: "#DB0263",
    opacity: 0.6,
    strokeColor: "#DB0263",
    pradeshName: "Harisharan Pradesh",
    displayName: "Nagpur",
  },
  bhopal: {
    filePath: "/map/geojson/geojson/Bhopal.geojson",
    color: "#DB0263",
    opacity: 0.6,
    strokeColor: "#DB0263",
    pradeshName: "Harisharan Pradesh",
    displayName: "Bhopal",
  },
  bengaluru: {
    filePath: "/map/geojson/geojson/Bengaluru.geojson",
    color: "#DB0263",
    opacity: 0.6,
    strokeColor: "#DB0263",
    pradeshName: "Harisharan Pradesh",
    displayName: "Bengaluru",
  },
  itarsi: {
    filePath: "/map/geojson/geojson/Itarsi-MP.geojson",
    color: "#DB0263",
    opacity: 0.6,
    strokeColor: "#DB0263",
    pradeshName: "Harisharan Pradesh",
    displayName: "Itarsi",
  },
  bhadohi: {
    filePath: "/map/geojson/geojson/Bhadohi-UP.geojson",
    color: "#DB0263",
    opacity: 0.6,
    strokeColor: "#DB0263",
    pradeshName: "Harisharan Pradesh",
    displayName: "Bhadohi",
  },
  moga: {
    filePath: "/map/geojson/geojson/Moga-Punjab.geojson",
    color: "#DB0263",
    opacity: 0.6,
    strokeColor: "#DB0263",
    pradeshName: "Harisharan Pradesh",
    displayName: "Moga",
  },
};

function formatValue(value, fallback = "N/A") {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }
  return value;
}

function appendCacheBuster(url, cacheBustToken) {
  if (!cacheBustToken) {
    return url;
  }
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}v=${encodeURIComponent(cacheBustToken)}`;
}

function buildImageUrl(fileName, cacheBustToken = "") {
  const imagePath = resolvePublicAssetPath(
    `/data/smruti/${encodeURIComponent(fileName)}`,
  );
  return appendCacheBuster(imagePath, cacheBustToken);
}

function buildThumbnailUrl(photo, cacheBustToken = "") {
  if (photo?.imagethumbnailfilename) {
    const thumbnailPath = resolvePublicAssetPath(
      `/data/smruti/thumbnail/${encodeURIComponent(photo.imagethumbnailfilename)}`,
    );
    return appendCacheBuster(thumbnailPath, cacheBustToken);
  }
  return buildImageUrl(photo.imagefilename, cacheBustToken);
}

function computeMarkerPosition(baseLat, baseLng, index, total) {
  if (total <= 1) {
    return { lat: baseLat, lng: baseLng };
  }

  const ringRadiusDegrees = 0.00018;
  const angle = (2 * Math.PI * index) / total;
  const latOffset = ringRadiusDegrees * Math.sin(angle);
  const cosLat = Math.cos((baseLat * Math.PI) / 180) || 1;
  const lngOffset = (ringRadiusDegrees * Math.cos(angle)) / cosLat;

  return {
    lat: baseLat + latOffset,
    lng: baseLng + lngOffset,
  };
}

function SmrutiMap() {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const infoWindowRef = useRef(null);
  const cityPolygonDataRef = useRef({});
  const markersRef = useRef([]);
  const [photoData, setPhotoData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [mapReady, setMapReady] = useState(false);
  const [geoJsonLoaded, setGeoJsonLoaded] = useState(false);
  const [refreshingAssets, setRefreshingAssets] = useState(false);
  const [cacheBustToken, setCacheBustToken] = useState("");

  const geotaggedPhotos = useMemo(
    () =>
      photoData.filter(
        (item) =>
          Number.isFinite(Number(item.imagelatitude)) &&
          Number.isFinite(Number(item.imagelongitude)),
      ),
    [photoData],
  );

  const loadPhotoData = useCallback(async ({ forceRefresh = false } = {}) => {
    const nextCacheBustToken = forceRefresh ? String(Date.now()) : "";
    const jsonPath = appendCacheBuster(
      resolvePublicAssetPath("/data/smruti/smruti-images.json"),
      nextCacheBustToken,
    );
    const response = await fetch(jsonPath, {
      cache: forceRefresh ? "no-store" : "default",
    });
    if (!response.ok) {
      throw new Error("Failed to load photo metadata");
    }
    const data = await response.json();
    setPhotoData(Array.isArray(data) ? data : []);
    setCacheBustToken(nextCacheBustToken);
  }, []);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError("");
    loadPhotoData()
      .catch(() => {
        if (cancelled) {
          return;
        }
        setError(
          "Could not load smruti-images.json. Run `npm run generate:smruti-json` first.",
        );
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [loadPhotoData]);

  const refreshAssetsFromServer = useCallback(async () => {
    setRefreshingAssets(true);
    setLoading(true);
    setError("");

    try {
      if (window.caches?.keys) {
        const cacheKeys = await window.caches.keys();
        await Promise.all(cacheKeys.map((key) => window.caches.delete(key)));
      }

      await loadPhotoData({ forceRefresh: true });
      setSelectedGroup(null);
      setSelectedIndex(0);
    } catch (refreshError) {
      console.error("Failed to refresh Smruti assets", refreshError);
      setError("Failed to refresh Smruti assets from server.");
    } finally {
      setRefreshingAssets(false);
      setLoading(false);
    }
  }, [loadPhotoData]);

  const focusMapArea = useCallback((areaConfig) => {
    const map = mapInstanceRef.current;
    if (!map) {
      return;
    }

    if (areaConfig.bounds) {
      const bounds = new window.google.maps.LatLngBounds(
        { lat: areaConfig.bounds.south, lng: areaConfig.bounds.west },
        { lat: areaConfig.bounds.north, lng: areaConfig.bounds.east },
      );
      map.fitBounds(bounds, 40);
      return;
    }

    if (areaConfig.center) {
      map.panTo(areaConfig.center);
      if (typeof areaConfig.zoom === "number") {
        map.setZoom(areaConfig.zoom);
      }
    }
  }, []);

  useEffect(() => {
    if (!mapRef.current || mapInstanceRef.current) {
      return;
    }

    let cancelled = false;
    (async () => {
      setOptions({
        key: GOOGLE_MAPS_API_KEY,
        version: GOOGLE_MAPS_VERSION,
      });
      const { Map } = await importLibrary("maps");
      if (cancelled) {
        return;
      }
      mapInstanceRef.current = new Map(mapRef.current, {
        mapId: "15431d2b469f209e",
        center: DEFAULT_CENTER,
        zoom: 16,
        gestureHandling: "greedy",
      });
      infoWindowRef.current = new window.google.maps.InfoWindow();
      setMapReady(true);
    })().catch(() => {
      setError("Failed to initialize Google Maps.");
    });

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!mapReady || !mapInstanceRef.current || geoJsonLoaded) {
      return;
    }

    let cancelled = false;
    (async () => {
      cityPolygonDataRef.current = {};
      const loadResults = await Promise.allSettled(
        Object.entries(cityGeoJsonConfig).map(async ([cityKey, config]) => {
          const response = await fetch(resolvePublicAssetPath(config.filePath));
          if (!response.ok) {
            throw new Error(`HTTP ${response.status} for ${config.filePath}`);
          }
          const geoJsonData = await response.json();
          if (!Array.isArray(geoJsonData?.features)) {
            throw new Error(`Invalid GeoJSON in ${config.filePath}`);
          }
          geoJsonData.features.forEach((feature) => {
            feature.properties.cityKey = cityKey;
          });
          return { cityKey, config, geoJsonData };
        }),
      );

      if (cancelled) {
        return;
      }

      let loadedLayers = 0;
      loadResults.forEach((result) => {
        if (result.status === "fulfilled") {
          const { cityKey, config, geoJsonData } = result.value;
          mapInstanceRef.current.data.addGeoJson(geoJsonData);
          cityPolygonDataRef.current[cityKey] = {
            cityName: config.displayName,
            pradeshName: config.pradeshName,
            color: config.color,
            opacity: config.opacity,
            strokeColor: config.strokeColor,
          };
          loadedLayers += 1;
          return;
        }

        console.error("Failed to load GeoJSON layer", result.reason);
      });

      if (loadedLayers === 0) {
        setError("Failed to load map GeoJSON layers.");
      }

      mapInstanceRef.current.data.setStyle((feature) => {
        const cityKey = feature.getProperty("cityKey");
        const config = cityPolygonDataRef.current[cityKey];

        if (!config) {
          return {
            fillColor: "#cccccc",
            fillOpacity: 0.3,
            strokeColor: "#666666",
            strokeWeight: 1,
          };
        }

        return {
          fillColor: config.color,
          fillOpacity: config.opacity,
          strokeColor: config.strokeColor,
          strokeWeight: 2,
        };
      });

      mapInstanceRef.current.data.addListener("click", (event) => {
        const cityKey = event.feature.getProperty("cityKey");
        const config = cityPolygonDataRef.current[cityKey];
        if (!config || !infoWindowRef.current) {
          return;
        }

        infoWindowRef.current.setContent(`
          <div class="map-info-content" style="
            font-family: Arial, sans-serif;
            padding: 10px;
            max-width: 220px;
            line-height: 1.5;
          ">
            <p style="margin: 0; font-weight: bold; color: #333;">${config.cityName}</p>
            <p style="margin: 0; font-weight: bold; color: #333;">${config.pradeshName}</p>
          </div>
        `);
        infoWindowRef.current.setPosition(event.latLng);
        infoWindowRef.current.open(mapInstanceRef.current);
      });
      setGeoJsonLoaded(true);
    })().catch(() => {
      if (!cancelled) {
        setError("Failed to load map GeoJSON layers.");
      }
    });

    return () => {
      cancelled = true;
    };
  }, [geoJsonLoaded, mapReady]);

  useEffect(() => {
    if (!mapReady || !geoJsonLoaded || !mapInstanceRef.current) {
      return;
    }

    let cancelled = false;
    (async () => {
      const { AdvancedMarkerElement } = await importLibrary("marker");
      if (cancelled) {
        return;
      }

      markersRef.current.forEach((marker) => {
        marker.map = null;
      });
      markersRef.current = [];

      if (!geotaggedPhotos.length) {
        mapInstanceRef.current.setCenter(DEFAULT_CENTER);
        mapInstanceRef.current.setZoom(4);
        return;
      }

      const bounds = new window.google.maps.LatLngBounds();
      const groupedPhotos = geotaggedPhotos.reduce((acc, photo) => {
        const lat = Number(photo.imagelatitude);
        const lng = Number(photo.imagelongitude);
        const key = `${lat.toFixed(6)}_${lng.toFixed(6)}`;
        if (!acc[key]) {
          acc[key] = { lat, lng, photos: [] };
        }
        acc[key].photos.push(photo);
        return acc;
      }, {});

      Object.values(groupedPhotos).forEach((group) => {
        group.photos.forEach((photo, photoIndex) => {
          const pinEl = document.createElement("div");
          pinEl.className = "smruti-marker";
          pinEl.title = photo.imagefilename;

          const preview = document.createElement("img");
          preview.className = "smruti-marker-image";
          preview.src = buildThumbnailUrl(photo, cacheBustToken);
          preview.alt = photo.imagefilename;
          preview.addEventListener("error", () => {
            if (
              photo.imagethumbnailfilename &&
              !preview.dataset.fallbackTried
            ) {
              preview.dataset.fallbackTried = "true";
              preview.src = buildImageUrl(photo.imagefilename, cacheBustToken);
              return;
            }
            preview.remove();
            pinEl.classList.add("smruti-marker--fallback");
            pinEl.textContent = "📷";
          });
          pinEl.appendChild(preview);

          const markerPosition = computeMarkerPosition(
            group.lat,
            group.lng,
            photoIndex,
            group.photos.length,
          );

          const marker = new AdvancedMarkerElement({
            map: mapInstanceRef.current,
            position: markerPosition,
            content: pinEl,
            title: photo.imagefilename,
          });

          marker.addListener("click", () => {
            setSelectedGroup(group.photos);
            setSelectedIndex(photoIndex);
          });

          markersRef.current.push(marker);
          bounds.extend(markerPosition);
        });
      });

      mapInstanceRef.current.fitBounds(bounds, 100);
    })().catch(() => {
      setError("Failed to place map markers.");
    });

    return () => {
      cancelled = true;
    };
  }, [cacheBustToken, geotaggedPhotos, geoJsonLoaded, mapReady]);

  const selectedPhoto = selectedGroup ? selectedGroup[selectedIndex] : null;
  const [previewUnavailable, setPreviewUnavailable] = useState(false);

  useEffect(() => {
    setPreviewUnavailable(false);
  }, [selectedPhoto?.imagefilename]);

  return (
    <main className="smruti-map-page themed-map-page">
      <header className="smruti-map-header">
        <h1>Smruti Map</h1>
        <div className="smruti-map-header-meta">
          <p>
            Smruti Map. Total photos: {photoData.length}, Geotagged:{" "}
            {geotaggedPhotos.length}
          </p>
          <button
            type="button"
            className="smruti-refresh-assets-button"
            onClick={refreshAssetsFromServer}
            disabled={refreshingAssets}
          >
            {refreshingAssets ? "Refreshing from server..." : "Refresh"}
          </button>
        </div>
        <div className="smruti-map-focus-controls">
          {MAP_FOCUS_AREAS.map((area) => (
            <button
              key={area.key}
              type="button"
              className="smruti-map-focus-button"
              onClick={() => focusMapArea(area)}
              disabled={!mapReady}
            >
              {area.label}
            </button>
          ))}
        </div>
      </header>

      {error && <div className="smruti-map-error">{error}</div>}

      {loading && (
        <div className="smruti-map-loading">Loading photo metadata...</div>
      )}

      <div className="smruti-map-canvas-wrap">
        <div ref={mapRef} className="smruti-map-canvas" />
      </div>

      {selectedPhoto && (
        <div
          className="smruti-photo-panel-overlay"
          onClick={() => setSelectedGroup(null)}
        >
          <section
            className="smruti-photo-panel"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="smruti-photo-close"
              onClick={() => setSelectedGroup(null)}
              aria-label="Close photo details"
            >
              ✕
            </button>

            {selectedGroup.length > 1 && (
              <div className="smruti-photo-nav">
                <button
                  type="button"
                  disabled={selectedIndex === 0}
                  onClick={() => setSelectedIndex((index) => index - 1)}
                >
                  Previous
                </button>
                <span>
                  {selectedIndex + 1} / {selectedGroup.length}
                </span>
                <button
                  type="button"
                  disabled={selectedIndex === selectedGroup.length - 1}
                  onClick={() => setSelectedIndex((index) => index + 1)}
                >
                  Next
                </button>
              </div>
            )}

            <div className="smruti-photo-preview">
              <img
                src={buildImageUrl(selectedPhoto.imagefilename, cacheBustToken)}
                alt={selectedPhoto.imagefilename}
                onError={(event) => {
                  event.currentTarget.classList.add(
                    "smruti-photo-preview--hidden",
                  );
                  setPreviewUnavailable(true);
                }}
              />
              {previewUnavailable && (
                <div className="smruti-photo-preview-fallback">
                  Preview not supported in this browser for this image type.
                </div>
              )}
            </div>

            <div className="smruti-photo-datetime">
              <p>
                <strong>Date:</strong> {formatValue(selectedPhoto.imagedate)}
              </p>
              <p>
                <strong>Time:</strong> {formatValue(selectedPhoto.imagetime)}
              </p>
            </div>
          </section>
        </div>
      )}
    </main>
  );
}

export default SmrutiMap;
